"use client";

import { useCallback } from "react";
import { DesktopVirtualizedTable } from "@/components/shared/DesktopVirtualizedTable";
import { WatchlistTableHeader } from "./WatchlistTableHeader";
import {
  WatchlistTableRow,
  type WatchlistContextAction,
} from "./WatchlistTableRow";
import {
  WATCHLIST_TABLE_CLASS,
  watchlistColSpan,
} from "./watchlistTableLayout";

export interface WatchlistTableProps {
  symbols: string[];
  columns: string[];
  emptyMessage?: string;
  selectedSymbol: string | null;
  onSymbolClick: (symbol: string) => void;
  onSymbolContextAction: (symbol: string, action: WatchlistContextAction) => void;
}

export function WatchlistTable({
  symbols,
  columns,
  emptyMessage = "No symbols in watchlist",
  selectedSymbol,
  onSymbolClick,
  onSymbolContextAction,
}: WatchlistTableProps) {
  const header = <WatchlistTableHeader columns={columns} />;

  const getRowKey = useCallback(
    (index: number) => symbols[index] ?? index,
    [symbols]
  );

  const renderRow = useCallback(
    (index: number) => {
      const currency = symbols[index];
      if (!currency) return null;
      return (
        <WatchlistTableRow
          key={currency}
          currency={currency}
          columns={columns}
          isSelected={selectedSymbol === currency}
          onSymbolClick={onSymbolClick}
          onSymbolContextAction={onSymbolContextAction}
        />
      );
    },
    [
      symbols,
      columns,
      selectedSymbol,
      onSymbolClick,
      onSymbolContextAction,
    ]
  );

  return (
    <DesktopVirtualizedTable
      rowCount={symbols.length}
      colSpan={watchlistColSpan(columns.length)}
      emptyMessage={emptyMessage}
      tableClassName={WATCHLIST_TABLE_CLASS}
      header={header}
      getRowKey={getRowKey}
      renderRow={renderRow}
    />
  );
}
